import {
  DateRow,
  ImageAndName,
  MobileCardBody,
  MobileCardFooter,
  PriceRow,
  StatusPopper,
  TextRow,
} from "components";
import { Svg } from "assets";
import { AllStatusesEnum } from "fragments";
import { CharityDetailsScreen } from "./charityDetailsScreen";
import { CharityBankAccount } from "./charityBankAccount";
import { CharityFundraiserReports } from "./charityFundraiserReports";
import { MobileCardHeadTitleName } from "../../../components/table/tableRows";
import { TransferStatusesRow } from "../../transfers/fragments/transferStatusesRow";

export const charityFundraiserFailedError = {
  NO_ACCOUNT:
    "You don't have a payment or a bank account connected. Please add an account and contact the admin",
  ACCOUNT_TRANSFER_ERROR:
    "Problem with the payment account information you provided. Please check the account details, make any necessary corrections, and then contact the admin to retry the payout.",
  BANK_TRANSFER_ERROR:
    "Problem with the bank account information you provided. Please check the account details, make any necessary corrections, and then contact the admin to retry the payout.",
};

export const charityDetailsTabs = {
  Details: "Details",
  BankAccount: "Bank Account",
  PendingBalance: "Pending Balance",
  Payouts: "Payouts",
  Failed: "Failed",
};

export const charityDetailTabs = [
  { label: charityDetailsTabs.Details },
  { label: charityDetailsTabs.BankAccount },
  { label: charityDetailsTabs.PendingBalance },
  { label: charityDetailsTabs.Payouts },
  { label: charityDetailsTabs.Failed },
];

export const tabsContent = [
  {
    tabComponent: <CharityDetailsScreen />,
    tab: "Details",
  },
  {
    tabComponent: <CharityBankAccount />,
    tab: "Bank Account",
  },
  {
    tabComponent: <CharityFundraiserReports status={AllStatusesEnum.PENDING} />,
    tab: "Pending Balance",
  },

  {
    tabComponent: <CharityFundraiserReports status={AllStatusesEnum.SUCCESS} />,
    tab: "Payouts",
  },

  {
    tabComponent: <CharityFundraiserReports status={AllStatusesEnum.FAILED} />,
    tab: "Failed",
  },
];

export const EDIT_CHARITY_ACTION = "EDIT_CHARITY";

export const CHARITY_BY_ID = "GET_CHARITY_BY_ID";

export const PUBLISH_ACTION = "CHANGE_FUNDRAISER_STATUS";

export const CHANGE_CHARITY_STATUS = "CHANGE_CHARITY_STATUS";
export const GET_MY_BANK = "GET_MY_BANK";
export const CHARITY_FUNDRAISER_REPORTS = "GET_CHARITY_REPORTS";

export const charityFundraiserReportsHead = (width, status) => {
  return width > 1279
    ? status === AllStatusesEnum.SUCCESS
      ? [
          { title: "Event Name", sortType: "name" },
          { title: "Created by", sortType: "owner" },
          { title: "Created Date", sortType: "createdAt" },
          { title: "Payout Date", sortType: "payoutDate" },
          { title: "Type" },
          { title: "Amount", sortType: "balance" },
        ]
      : status === AllStatusesEnum.FAILED
      ? [
          { title: "Event Name", sortType: "name" },
          { title: "Created by", sortType: "owner" },
          { title: "Created Date", sortType: "createdAt" },
          { title: "Payout Date", sortType: "payoutDate" },
          { title: "Type" },
          { title: "Amount", sortType: "balance" },
          { title: "Status" },
        ]
      : [
          { title: "Event Name", sortType: "name" },
          { title: "Created by", sortType: "owner" },
          { title: "Date", sortType: "endDate" },
          { title: "Type" },
          { title: "Amount", sortType: "balance" },
          { title: "Status" },
        ]
    : status === AllStatusesEnum.SUCCESS
    ? [
        { title: "Event Name", sortType: "name" },
        { title: "Payout Date", sortType: "payoutDate" },
        { title: "Amount" },
      ]
    : status === AllStatusesEnum.FAILED
    ? [
        { title: "Event Name", sortType: "name" },
        { title: "Amount", sortType: "balance" },
        { title: "Status" },
      ]
    : [
        { title: "Event Name", sortType: "name" },
        { title: "Amount", sortType: "balance" },
        { title: "Status" },
      ];
};

export const charityFundraiserReportsBody = (width, status) => {
  return width > 1279
    ? status === AllStatusesEnum.SUCCESS
      ? [
          {
            rowText: (item) => (
              <ImageAndName
                text={item?.name}
                src={
                  item?.images?.length
                    ? item?.images[item?.mainImage || 0]?.url
                    : null
                }
                noSrc={<Svg.NoFundraiserImage />}
              />
            ),
          },
          {
            rowText: (item) => <TextRow text={item?.owner} />,
          },
          {
            rowText: (item) => <DateRow date={item?.createdAt} />,
          },
          {
            rowText: (item) => <DateRow date={item?.payoutDate} />,
          },
          {
            rowText: (item) => (
              <TextRow
                text={
                  item?.type === "CELEBRATION"
                    ? "In Celebration "
                    : "In Memory of"
                }
              />
            ),
          },
          {
            rowText: (item) => <PriceRow info={item?.amount} />,
          },
        ]
      : status === AllStatusesEnum.FAILED
      ? [
          {
            rowText: (item) => (
              <ImageAndName
                text={item?.name}
                src={
                  item?.images?.length
                    ? item?.images[item?.mainImage || 0]?.url
                    : null
                }
                noSrc={<Svg.NoFundraiserImage />}
              />
            ),
          },
          {
            rowText: (item) => <TextRow text={item?.owner} />,
          },
          {
            rowText: (item) => <DateRow date={item?.createdAt} />,
          },
          {
            rowText: (item) => <DateRow date={item?.payoutDate} />,
          },
          {
            rowText: (item) => (
              <TextRow
                text={
                  item?.type === "CELEBRATION"
                    ? "In Celebration "
                    : "In Memory of"
                }
              />
            ),
          },
          {
            rowText: (item) => <PriceRow info={item?.amount} />,
          },

          {
            rowText: (item) => (
              <TransferStatusesRow
                item={item}
                toolTipText={charityFundraiserFailedError?.[item?.status]}
                showReTransferIcon={false}
              />
            ),
          },
        ]
      : [
          {
            rowText: (item) => (
              <ImageAndName
                text={item?.name}
                src={
                  item?.images?.length
                    ? item?.images[item?.mainImage || 0]?.url
                    : null
                }
                noSrc={<Svg.NoFundraiserImage />}
              />
            ),
          },
          {
            rowText: (item) => <TextRow text={item?.owner} />,
          },
          {
            rowText: (item) => <DateRow date={item?.createdAt} />,
          },
          {
            rowText: (item) => (
              <TextRow
                text={
                  item?.type === "CELEBRATION"
                    ? "In Celebration "
                    : "In Memory of"
                }
              />
            ),
          },
          {
            rowText: (item) => <PriceRow info={item?.amount} />,
          },

          {
            rowText: (item) => <StatusPopper status={item?.status} />,
          },
        ]
    : status === AllStatusesEnum.SUCCESS
    ? [
        {
          rowText: (item) => <TextRow text={item?.name} />,
          width: "33%",
        },

        {
          rowText: (item) => <DateRow date={item?.payoutDate} />,
          width: "33%",
        },

        {
          rowText: (item) => <PriceRow info={item?.amount} />,
          width: "33%",
        },
      ]
    : status === AllStatusesEnum.FAILED
    ? [
        {
          rowText: (item) => <TextRow text={item?.name} />,
          width: "33%",
        },
        {
          rowText: (item) => <PriceRow info={item?.amount} />,
          width: "33%",
        },
        {
          rowText: (item) => (
            <TransferStatusesRow
              item={item}
              toolTipText={charityFundraiserFailedError?.[item?.status]}
              showReTransferIcon={false}
            />
          ),
          width: "33%",
        },
      ]
    : [
        {
          rowText: (item) => <TextRow text={item?.name} />,
          width: "33%",
        },
        {
          rowText: (item) => <PriceRow info={item?.amount} />,
          width: "33%",
        },
        {
          rowText: (item) => <StatusPopper status={item?.status} />,
          width: "33%",
        },
      ];
};

export const fundraiserMobileCard = (status) => {
  return status === AllStatusesEnum.SUCCESS
    ? [
        {
          rowText: (item) => (
            <MobileCardHeadTitleName title="Event Name:" value={item?.name} />
          ),
        },
        {
          rowText: (item) => (
            <MobileCardBody
              title="Created by"
              value={<TextRow text={item?.owner} />}
            />
          ),
        },
        {
          rowText: (item) => (
            <MobileCardBody
              title="Date"
              value={<DateRow date={item?.createdAt} />}
            />
          ),
        },

        {
          rowText: (item) => (
            <MobileCardBody
              title="Payout Date"
              value={<DateRow date={item?.payoutDate} />}
            />
          ),
        },
        {
          rowText: (item) => (
            <MobileCardBody
              title="Type"
              value={
                <TextRow
                  text={
                    item?.type === "CELEBRATION"
                      ? "In Celebration "
                      : "In Memory of"
                  }
                />
              }
            />
          ),
        },
        {
          rowText: (item) => (
            <MobileCardBody
              title="Amount"
              value={<PriceRow info={item?.amount} />}
            />
          ),
        },
      ]
    : status === AllStatusesEnum.FAILED
    ? [
        {
          rowText: (item) => (
            <MobileCardHeadTitleName title="Event Name:" value={item?.name} />
          ),
        },
        {
          rowText: (item) => (
            <MobileCardBody
              title="Created by"
              value={<TextRow text={item?.owner} />}
            />
          ),
        },
        {
          rowText: (item) => (
            <MobileCardBody
              title="Date"
              value={<DateRow date={item?.createdAt} />}
            />
          ),
        },

        {
          rowText: (item) => (
            <MobileCardBody
              title="Payout Date"
              value={<DateRow date={item?.payoutDate} />}
            />
          ),
        },
        {
          rowText: (item) => (
            <MobileCardBody
              title="Type"
              value={
                <TextRow
                  text={
                    item?.type === "CELEBRATION"
                      ? "In Celebration "
                      : "In Memory of"
                  }
                />
              }
            />
          ),
        },
        {
          rowText: (item) => (
            <MobileCardBody
              title="Amount"
              value={<PriceRow info={item?.amount} />}
            />
          ),
        },
        {
          rowText: (item) => (
            <MobileCardFooter
              title="Status"
              value={
                <TransferStatusesRow
                  item={item}
                  toolTipText={charityFundraiserFailedError?.[item?.status]}
                  showReTransferIcon={false}
                />
              }
            />
          ),
        },
      ]
    : [
        {
          rowText: (item) => (
            <MobileCardHeadTitleName title="Event Name:" value={item?.name} />
          ),
        },
        {
          rowText: (item) => (
            <MobileCardBody
              title="Created by"
              value={<TextRow text={item?.owner} />}
            />
          ),
        },
        {
          rowText: (item) => (
            <MobileCardBody
              title="Date"
              value={<DateRow date={item?.createdAt} />}
            />
          ),
        },
        {
          rowText: (item) => (
            <MobileCardBody
              title="Type"
              value={
                <TextRow
                  text={
                    item?.type === "CELEBRATION"
                      ? "In Celebration "
                      : "In Memory of"
                  }
                />
              }
            />
          ),
        },
        {
          rowText: (item) => (
            <MobileCardBody
              title="Amount"
              value={<PriceRow info={item?.amount} />}
            />
          ),
        },
        {
          rowText: (item) => (
            <MobileCardFooter
              title="Status"
              value={<StatusPopper status={item?.status} />}
            />
          ),
        },
      ];
};

// eslint-disable-next-line react/display-name
export const charityReportsAccordionDetails = () => (item) => {
  return (
    <div className="charity-reports-accordion-details-wrapper">
      <div className="charity-reports-accordion-details-block">
        <span>Creation Date:</span> <DateRow date={item?.createdAt} />
      </div>
      <div className="charity-reports-accordion-details-block">
        <span>Created By:</span> <TextRow text={item?.owner} />
      </div>
      <div className="charity-reports-accordion-details-block">
        <span>Type:</span>{" "}
        <TextRow
          text={
            item?.type === "CELEBRATION" ? "In Celebration " : "In Memory of"
          }
        />
      </div>
    </div>
  );
};
